// Pure helpers for the Webhooks page: words for statuses, a hook's recent bars, and the delivery log filter.
export const STATUS = {
  active: { label: 'Working', color: '#22c55e' },
  failing: { label: 'Failing', color: '#ef4444' },
  disabled: { label: 'Paused', color: '#94a3b8' }
};

export const rateOf = (hook) => {
  const total = (hook.success_count || 0) + (hook.failure_count || 0);
  return total ? Math.round((hook.success_count / total) * 100) : null;
};

// The last 10 deliveries of one webhook, oldest first, for the little bars.
export const recentBars = (deliveries, hookId, max = 10) => deliveries.filter((d) => d.webhook === hookId).slice(0, max).reverse();

export const logRows = (deliveries, onlyFailed) => (onlyFailed ? deliveries.filter((d) => !d.ok) : deliveries);

export const eventLabel = (events, id) => events.find((e) => e.id === id)?.label || id;

// "Failing" hooks with the reason, for the red banner.
export const failingNotes = (hooks) => hooks.filter((h) => h.status === 'failing').map((h) => ({ id: h.id, name: h.name, reason: h.last_error || 'Deliveries are being refused.' }));

export const asPayload = (form, editing) => {
  const out = { name: form.name.trim(), url: form.url.trim(), events: form.events };
  if (form.secret || !editing) out.secret = form.secret;
  return out;
};
